import { render, staticRenderFns } from "./DeleteBankAccountModal.vue?vue&type=template&id=6b2fa153&scoped=true"
import script from "./DeleteBankAccountModal.vue?vue&type=script&lang=js"
export * from "./DeleteBankAccountModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteBankAccountModal.vue?vue&type=style&index=0&id=6b2fa153&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2fa153",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b2fa153')) {
      api.createRecord('6b2fa153', component.options)
    } else {
      api.reload('6b2fa153', component.options)
    }
    module.hot.accept("./DeleteBankAccountModal.vue?vue&type=template&id=6b2fa153&scoped=true", function () {
      api.rerender('6b2fa153', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/data/components/Modal/DeleteBankAccountModal.vue"
export default component.exports